export const CommonApiEndpoint = {
  fetchProduct: '/product', // 식음료 조회
  fetchProductClass: '/product/product-class', //식음료 카테고리 탭 조회
};
